import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { loginApplicationLoggerToken } from "../../apps/login/tokens";
import ShopBrandInfoEntity from "./ShopBrandInfoEntity";
import { ShopBrandInfoProviderInterface } from "./ShopBrandInfoProviderInterface";
import { AdditionalShopBrandInfoSchema } from "./ShopBrandInfoSchema";

@singleton()
class ShopBrandInfoFromJsonProvider implements ShopBrandInfoProviderInterface {
    private shopBrandInfo: ShopBrandInfoEntity | null = null;

    constructor(
        @inject(loginApplicationLoggerToken)
        private readonly logger: LoggerInterface,
        private readonly additionalInfoData: unknown
    ) {}

    readData(): void {
        const additionalInfo = create(
            this.additionalInfoData,
            AdditionalShopBrandInfoSchema
        );
        this.shopBrandInfo = additionalInfo.GW_SHOP_BRAND_INFO;
        this.logger.debug("shop brand info provider is ready", {
            shopBrandInfo: this.shopBrandInfo,
        });
    }

    getLogoUrl(): string | null {
        return this.shopBrandInfo?.logoUrl || null;
    }
}

export default ShopBrandInfoFromJsonProvider;
